import React from 'react';
import './style.css';

const ErrorsMessage = ({ message }) => (
  <div className="app-error">{message}</div>
);

export default ErrorsMessage;
